module.exports = __webpack_public_path__ + "img/dataV_A.e8cb4896.png";